
import EventService from '../../services/events'

export const state = {}

export const mutations = {}


export const getters = {}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {},

  // eslint-disable-next-line no-unused-vars
  createEvent ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      
      EventService.createEvent(payload).then(response => { 
        if (response.data && response.data.data._id) { 
          resolve(response)
        }else{
          reject({message: 'Error creating event'})
        }
      })
      .catch(error => { reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getEvents ({ commit },params) {

    return new Promise((resolve, reject) => { 
      EventService.getEvents(params).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getEvent ({ commit }, id) {

    return new Promise((resolve, reject) => { 
      EventService.getEvent(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  deleteEvent ({ commit }, id) {

    return new Promise((resolve, reject) => { 
      EventService.deleteEvent(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateEvent ({ commit }, event) {

    return new Promise((resolve, reject) => { 
      EventService.updateEvent(event).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getHostsAvailable ({ commit }, id) {

    return new Promise((resolve, reject) => { 
      EventService.getHostsAvailable(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },
  
  // eslint-disable-next-line no-unused-vars
  createShowEvent ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      
      EventService.createShowEvent(payload).then(response => { 
        if (response.data && response.data.data._id) { 
          resolve(response)
        }else{
          reject({message: 'Error creating event'})
        }
      })
      .catch(error => { reject(error) })
    });
  },
}